export default "__VITE_ASSET__B3Hr48zN__"